import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from 'shared/components/Icon';
import {
  CommentContainer,
  CommentText,
  CommentTitleContainer,
  CommentTitleText,
} from './style';

type CommentProps = {
  comments?: string;
};

export const Comment = (props: CommentProps) => {
  const { t } = useTranslation();
  return (
    <>
      <CommentContainer>
        <CommentTitleContainer>
          <Icon fill="#6F7C87" glyph="comment" width={18} height={18} />
          <CommentTitleText>{`${t(
            'contacts.import_contact.default_fields.response.comment',
          )}`}</CommentTitleText>
        </CommentTitleContainer>
        <CommentText>{props?.comments?.toString()}</CommentText>
      </CommentContainer>
    </>
  );
};
